import React, { useMemo, useState } from "react";
import { Box, Chip, Divider, Grid, Tooltip, Typography } from "@mui/material";
import { IconButtonComponent, PaginationTable, TextIconButtonComponent } from "../../atom";
import {  faTrash } from "@fortawesome/free-solid-svg-icons";

const ViewSelectedCoursePlan = ({ list = [], onClickRemove = () => {} }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const totalItems = list?.length;
  const paginatedData = useMemo(() => {
      const startIndex = (currentPage - 1) * rowsPerPage;
      const endIndex = startIndex + rowsPerPage;
  
      return list.slice(startIndex, endIndex);
  }, [list, currentPage, rowsPerPage]);

  const columns = [
      { name: "courseId", label: "courseId", options: { display: false } },
      { name: "planId", label: "planId", options: { display: false } },
      {
        name: "course_name",
        label: "Course",
        options: {
          filter: true,
          sort: false,
          display: true,
          customBodyRender: (value, tableMeta) => {
            const courses = [value];
  
            if (!courses.length) return "-";
  
            return (
              <Box width={"200px"}>
                <Box>
                  {courses.map((item, idx) => {
                    const courseName = item || "";
                    const needsTooltip = courseName.length > 50;
                    const displayedText = needsTooltip
                      ? `${courseName.substring(0, 50)}...`
                      : courseName;
  
                    return (
                      <Typography 
                       component={"span"} 
                       key={`${tableMeta.rowIndex}-${item || idx}`}>
                        {needsTooltip ? (
                          <Tooltip title={courseName} placement="top" arrow>
                            <span style={{ cursor: "pointer" }}>
                              {displayedText}
                            </span>
                          </Tooltip>
                        ) : (
                          displayedText
                        )}
                      </Typography>
                    );
                  })}
                </Box>
              </Box>
            );
          },
        },
      },
      {
        name: "plan_name",
        label: "Plan",
        options: {
          filter: true,
          sort: false,
          customBodyRender: (value, tableMeta) => {
            const plans = [value];
  
            if (!plans.length) return "-";
  
            return (
              <Box width={"200px"}>
                <Box>
                  {plans.map((item, idx) => {
                    const plan = item || "";
                    const needsTooltip = plan.length > 20;
                    const displayedText = needsTooltip
                      ? `${plan.substring(0, 20)}...`
                      : plan;
  
                    return (
                      <Typography 
                       component={"span"} 
                       key={`${tableMeta.rowIndex}-${item || idx}`}>
                        {needsTooltip ? (
                          <Tooltip title={plan} placement="top" arrow>
                            <span style={{ cursor: "pointer" }}>
                              {displayedText}
                            </span>
                          </Tooltip>
                        ) : (
                          displayedText
                        )}
                      </Typography>
                    );
                  })}
                </Box>
              </Box>
            );
          },
        },
      },
      {
        name: "",
        label: "",
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta) => {
           const courseId = tableMeta?.rowData?.[0]
           const planId = tableMeta?.rowData?.[1]
           const item = list?.find((plan)=> plan?.courseId?.toString() === courseId?.toString() && plan?.planId?.toString() === planId?.toString() )

           return (
            <Box sx={{ minWidth: 80, maxWidth: 80 }}>
              <IconButtonComponent
                btnType={"deleteIconbtn"}
                onclick={() => onClickRemove(item)}
              />
            </Box>
           )
          }
        },
      },
  ];


  return (
    <>
      <Box>
        <PaginationTable
          columns={columns}
          data={paginatedData}
          totalItems={totalItems}
          currentPage={currentPage}
          rowsPerPage={rowsPerPage}
          onPageChange={(page) => {
            setCurrentPage(page);
          }}
          onRowsPerPageChange={(perPage) => {
            setRowsPerPage(perPage);
            setCurrentPage(1);
          }}
          hideDownloadButton={true}
          filter={false}
          search={false}
          name={""}
        />
      </Box>
    </>
  );
};

export default ViewSelectedCoursePlan;
